{
  "verified": "Проверено",
  "iv_status": {
    "verified": "Проверено",
    "pending": "В ожидании",
    "attention": "Внимание"
  },
  "zoom_in": "Увеличить",
  "zoom_out": "Уменьшить масштаб",
  "rotate": "Повернуть",
  "close": "Закрыть",
  "esc_to_close": "Нажмите ESC, чтобы закрыть",
  "play": "Играть",
  "pause": "Пауза",
  "mute": "Отключить звук",
  "unmute": "Отключить",
  "enter_full_screen": "Войти в полноэкранный режим",
  "exit_full_screen": "Выход в полноэкранном режиме",
  "video_not_supported": "Ваш браузер не поддерживает тег видео.",
  "skip_forward": "Пропустить вперед",
  "skip_backward": "Пропустить назад",
  "loading": "Загрузка",
  "loading_video": "Загрузка видео...",
  "loading_data_description": "Пожалуйста, подождите, пока мы загрузим ваши данные. Это не займет много времени.",
  "no_results": "Нет результатов",
  "nothing_found": "Ничего не найдено",
  "save_changes": "Сохранить изменения",
  "saved_exclamation": "Спасен!",
  "saving": "Экономия",
  "validating": "Проверка",
  "error": "Ошибка",
  "optional": "Дополнительно",
  "search_property": "Поиск недвижимости",
  "reset_search": "Сброс поиска",
  "no_items_to_show": "Нет предметов для показа",
  "showing_range_of_total_items": "Показать {{range}} из {{total}} предметов",
  "rows_per_page": "Строки на странице",
  "page_of_pages": "Страница {{page}} из {{pages}}",
  "go_to_first_page": "Перейти на первую страницу",
  "go_to_previous_page": "Перейти на предыдущую страницу",
  "go_to_next_page": "Перейти на следующую страницу",
  "go_to_last_page": "Перейти на последнюю страницу",
  "sort_in_asc": "Сортировка по возрастанию",
  "sort_in_desc": "Сортировка по убыванию",
  "sort_a_z": "Сортировка A → Z",
  "sort_z_a": "Сортировка Z → A",
  "clear_sorting": "Четкая сортировка",
  "reach_us_at_email": "Обращайтесь за поддержкой по адресу support@chekin.com.",
  "please_wait": "Пожалуйста, подождите",
  "feature_coming_soon": "Скоро будет",
  "feature_coming_soon_description": "Эта функция находится в стадии разработки и скоро будет доступна. Следите за обновлениями!",
  "download_all": "Скачать все",
  "entry_forms": "Бланки заявок",
  "tutorial": "Учебное пособие",
  "liveness_video": "Видеоролик Liveness",
  "beta": "Бета",
  "reviews": "Отзывы",
  "learn_more": "Узнать больше",
  "this_cannot_be_reverted": "Это нельзя изменить",
  "delete": "Удалить",
  "cancel": "Отмена",
  "you_have_made_changes": "Вы внесли изменения",
  "would_you_like_to_save_them": "Хотите спасти их?",
  "save": "Сохранить",
  "dont_save": "Не экономьте",
  "copied_exclamation": "Скопировано!",
  "search_placeholder": "Поиск...",
  "type_to_search": "Введите для поиска...",
  "loading_more": "Загрузка...",
  "no_options": "Без вариантов",
  "select_option": "Выберите вариант",
  "clear_all": "Очистить все",
  "remove_item": "Удалите {{label}}",
  "upload_file": "Загрузить файл",
  "download_attachment": "Загрузить вложение",
  "remove_file": "Удалить файл",
  "open_calendar": "Открытый календарь",
  "clear_dates": "Четкие даты",
  "select_dates": "Выберите даты",
  "pick_date_range": "Выберите диапазон дат",
  "from": "С сайта",
  "to": "На",
  "pick_month": "Выберите месяц",
  "pick_date": "Выберите дату",
  "month": "Месяц",
  "day": "День",
  "year": "Год",
  "done": "Готово",
  "wrong_period_of_dates": "Выбранный период недействителен",
  "date_range_max_days_error_one": "Диапазон не может превышать {{count}} дня",
  "date_range_max_days_error_other": "Диапазон не может превышать {{count}} дней",
  "date_range_min_days_error_one": "Диапазон должен быть не менее {{count}} дня",
  "date_range_min_days_error_other": "Диапазон должен составлять не менее {{count}} дней",
  "past_dates": "Дата не может быть раньше {{minDate}}",
  "future_dates": "Дата не может быть после {{maxDate}}",
  "signature_placeholder_text": "Распишитесь в этом поле.<br/> Используйте палец.<br/> Нажмите, чтобы начать.",
  "open_devices_camera": "Откройте камеру устройства",
  "place_document_inside_frame": "Поместите документ в рамку",
  "close_other_application_that_may_be_using_your_camera": "Закройте другие приложения, которые могут использовать вашу камеру",
  "if_you_use_external_camera_disconnect_and_reconnect": "Если вы используете внешнюю камеру, отсоедините и снова подсоедините ее",
  "close_the_browser_re_open_it": "Закройте браузер и откройте его снова",
  "camera_errors": {
    "experiencing_camera_issues": "Испытываете проблемы с камерой?",
    "chekin_cant_use_your_camera": "Чекин не может пользоваться вашей камерой",
    "please_try_a_different_browser": "Ваша камера не работает в этом браузере. Пожалуйста, попробуйте открыть ссылку в другом браузере.",
    "permissions_denied": "Разрешение отклонено",
    "camera_permissions_denied": "Камера не открывается? Убедитесь, что разрешили браузеру использовать камеру.",
    "no_camera_device_found": "Устройство камеры не найдено. Пожалуйста, подключите камеру.",
    "constraints_camera_error": "Ограничения не могут быть удовлетворены имеющимися устройствами.",
    "safari_camera_error": "Safari не смогла удовлетворить требования камеры",
    "try_chrome_or_firefox": "Пожалуйста, попробуйте Chrome или Firefox"
  },
  "clear": "Очистить",
  "show_less": "Показать меньше",
  "show_more": "Показать еще",
  "tap_here_to_sign": "Нажмите здесь, чтобы подписать",
  "click_here_to_sign": "Нажмите здесь, чтобы подписать",
  "prefix": "Префикс",
  "prefix_required": "Префикс обязателен",
  "reset": "Сброс",
  "show_password": "Показать пароль",
  "hide_password": "Скрыть пароль",
  "increment": "Инкремент",
  "decrement": "Уменьшение",
  "create_option": "Создайте \"{{input}}\"",
  "year_out_of_range": "Год должен быть между {{min}} и {{max}}",
  "clear_date": "Четкая дата",
  "select_date": "Выберите дату",
  "draw_signature_here": "Поставьте здесь свою подпись",
  "signature_hint": "Используйте мышь или палец",
  "clear_signature": "Четкая подпись",
  "draw_signature_here_mobile": "Нарисуйте свою подпись",
  "signature_hint_mobile": "Используйте палец",
  "camera_access_needed": "Требуется доступ к камере",
  "camera_access_needed_text": "Разрешите камере доступ для съемки фотографии. Если доступ заблокирован, включите камеру в настройках браузера, а затем попробуйте ещё раз.",
  "dialog": "Диалог"
}
